export const featureLabelMap: Record<string, string> = {
  // Assistance Systems
  abs: 'Anti-lock braking system (ABS)',
  esp: 'Electronic Stability Program (ESP)',
  asr: 'Traction control (ASR)',
  hill_start: 'Hill start assist',
  fatigue_warning: 'Fatigue warning',
  lane_keeping: 'Lane keeping assistant',
  blind_spot: 'Blind Spot Assist',
  interior_mirror: 'Interior mirror with automatic dimming',
  night_vision: 'Night Vision Assistant',
  emergency_braking: 'Emergency braking assistant',
  emergency_call: 'Emergency call system',
  traffic_sign: 'Traffic sign recognition',
  distance_warning: 'Distance warning',

  // Cruise Control
  none: 'None',
  standard: 'Cruise control',
  adaptive: 'Adaptive cruise control',
  speed_limiter: 'Speed limiter',

  // Airbags
  driver_airbag: 'Driver airbag',
  front_airbags: 'Front airbags',
  front_side: 'Front and side airbags',
  front_side_additional: 'Front, side and additional airbags',
  curtain_airbags: 'Curtain airbags',
  knee_airbags: 'Knee airbags',

  // Isofix
  isofix: 'Isofix (child seat attachment)',
  isofix_passenger: 'Isofix passenger seat',

  // Headlights
  halogen: 'Halogen headlights',
  xenon: 'Xenon headlights',
  bi_xenon: 'Bi-Xenon headlights',
  led: 'LED headlights',
  laser: 'Laser light',

  // Light and Visibility
  headlight_cleaning: 'Headlight cleaning',
  glare_free_highbeam: 'Glare-free high beam',
  highbeam_assistant: 'High beam assistant',
  front_fog: 'Front fog lights',

  // Theft Protection
  alarm_system: 'Alarm system',
  electric_immobilizer: 'Electric immobilizer',
  steering_lock: 'Steering lock',
  central_locking: 'Central locking',

  // Air Conditioning
  manual: 'Air conditioning',
  automatic: 'Automatic air conditioning',
  '2_zone': '2-zone automatic climate control',
  '3_zone': '3-zone automatic climate control',
  '4_zone': '4-zone automatic climate control',

  // Air Conditioning Features
  auxiliary_heating: 'Auxiliary heating',
  heated_windshield: 'Heated windshield',
  heated_steering_wheel: 'Heated steering wheel',
  heated_seats: 'Heated seats',
  ventilated_seats: 'Ventilated seats',
  massage_seats: 'Massage seats',

  // Parking Aids
  front_sensors: 'In front',
  rear_sensors: 'Rear',
  side_sensors: 'Side sensors',
  front_rear: 'Front and rear',
  rear_camera: 'Camera',
  '360_camera': '360° camera',
  front_camera: 'Front camera',
  birdseye_view: "Bird's eye view",
  parking_sensors: 'Parking sensors',
  rear_view_camera: 'Rear view camera',

  // Seat Features
  front_heating: 'In front',
  rear_heating: 'Rear',
  driver_heating: 'Driver seat',
  passenger_heating: 'Passenger seat',
  front_electric: 'In front',
  rear_electric: 'Rear',
  driver_electric: 'Driver seat',
  passenger_electric: 'Passenger seat',
  memory_seats: 'Memory seats',
  sports_seats: 'Sports seats',
  armrest: 'Armrest',
  lumbar_support: 'Lumbar support',
  leather_seats: 'Leather seats',
  alcantara_seats: 'Alcantara seats',

  // Comfort Features
  electric_windows: 'Electric windows',
  electric_side_mirrors: 'Electric side mirrors',
  electric_tailgate: 'Electric tailgate',
  keyless_central_locking: 'Keyless central locking (Keyless)',
  light_sensor: 'Light sensor',
  rain_sensor: 'Rain sensor',
  power_steering: 'Power steering',
  ambient_lighting: 'Ambient lighting',
  leather_steering_wheel: 'Leather steering wheel',
  cruise_control: 'Cruise control',
  start_stop_system: 'Start-stop system',
  hill_start_assist: 'Hill start assist',

  // Multimedia
  tuner_radio: 'Tuner/Radio',
  radio_dab: 'Radio DAB',
  cd_player: 'CD player',
  tv: 'TV',
  navigation_system: 'Navigation system',
  sound_system: 'Sound system',
  usb: 'USB',
  bluetooth: 'Bluetooth',
  apple_carplay: 'Apple CarPlay',
  android_auto: 'Android Auto',
  wlan_wifi_hotspot: 'WLAN / Wi-Fi hotspot',
  music_streaming: 'Music streaming integrated',
  music_streaming_integrated: 'Music streaming integrated',

  // Operation and Control
  touchscreen: 'Touchscreen',
  voice_control: 'Voice control',
  multifunction_steering_wheel: 'Multifunction steering wheel',
  hands_free_system: 'Hands-free system',

  // Instrument Display
  onboard_computer: 'On-board computer',
  head_up_display: 'Head-Up Display',
  digital_instrument_cluster: 'Fully digital instrument cluster',

  // Connectivity and Interfaces
  induction_charging_smartphones: 'Induction charging for smartphones',
  aux_input: 'AUX input',
  hdmi_input: 'HDMI input',
  wireless_charging: 'Wireless charging',
  nfc: 'NFC',
  mirrorlink: 'MirrorLink',

  // Tires and Rims
  alloy_wheels: 'Alloy wheels',
  summer_tires: 'Summer tires',
  winter_tires: 'Winter tires',
  all_season_tires: 'All-season tires',
  run_flat_tires: 'Run-flat tires',

  // Breakdown Assistance
  roadside_assistance: 'Roadside assistance',
  breakdown_service: 'Breakdown service',
  accident_recovery: 'Accident recovery',
  towing_service: 'Towing service',

  // Special Equipment
  winter_package: 'Winter package',
  smokers_package: "Smoker's package",
  sports_package: 'Sports package',
  sports_suspension: 'Sports suspension',
  air_suspension: 'Air suspension',
  luxury_package: 'Luxury package',
  comfort_package: 'Comfort package',

  // Trailer Hitch
  fixed: 'Fixed trailer hitch',
  removable: 'Removable trailer hitch',
  electrical_connection: 'With electrical connection',

  // Additional Extras
  luggage_compartment_partition: 'Luggage compartment partition',
  ski_bag: 'Ski bag',
  sunroof: 'Sunroof',
  panoramic_roof: 'Panoramic roof',
  roof_rails: 'Roof rails',
  accessible: 'Accessible',
  taxi: 'Taxi',
  first_aid_kit: 'First aid kit',
  warning_triangle: 'Warning triangle',
  spare_wheel: 'Spare wheel',
};

export const getFeatureLabel = (featureValue: string): string => {
  if (!featureValue) return featureValue;

  if (featureLabelMap[featureValue]) {
    return featureLabelMap[featureValue];
  }

  return featureValue
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const getFeatureLabels = (featureValues: string[]): string[] => {
  if (!featureValues || !Array.isArray(featureValues)) return [];
  return featureValues.map(getFeatureLabel);
};
